import styles from './styles'
import PropTypes from 'prop-types'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import { IconButton } from 'foundations-library/components'

const useStyles = makeStyles(styles)

type AppName = 'calls' | 'faxes' | 'messages' | 'contact'

interface Props {
    app: AppName
    title: string
    onClick: () => void
    disabled?: boolean
    className?: string
    icon?: JSX.Element
    rightIcon?: boolean
    spaceBetween?: boolean
    hideIcon?: boolean
}

/***/
/**
 *
 */
const StartNewButton = (props: Props): JSX.Element => {
    const classes = useStyles()

    let iconProps = {
        name: 'dialpad-10',
        'data-testid': 'start-conversation'
    }

    switch (props.app) {
            case 'calls':
                iconProps = {
                    ...iconProps,
                    name: 'dialpad-10',
                    'data-testid': 'make-call'
                }
                break
            case 'messages':
                iconProps = {
                    ...iconProps,
                    name: 'text',
                    'data-testid': 'start-conversation',
                    iconProps: {
                        colors: ['white', props.disabled ? 'neutral-200' : 'primary']
                    }
                }
                break
            case 'faxes':
                iconProps = {
                    ...iconProps,
                    name: 'add-button',
                    'data-testid': 'send-fax',
                    iconProps: { color: 'transparent', size: 32 }

                }
                break
            case 'contact':
                iconProps = {
                    ...iconProps,
                    name: 'add-user',
                    'data-testid': 'contact',
                    iconProps: { color: 'white' }
                }
                break
    }

    const icon = (
        <div className={classes.iconContainer}>
            {props.icon || (
                <IconButton
                    className={classes.startNewIcon}
                    onClick={props.onClick}
                    size='small'
                    disabled={props.disabled}
                    {...iconProps}
                />
            )}
        </div>
    )

    return (
        <button
            className={`${classes.startNewButton} ${props.className || ''}`}
            onClick={props.onClick}
            disabled={props.disabled}
        >
            <div
                className={classes.content}
                style={{
                    flexDirection: props.rightIcon ? 'row-reverse' : 'row',
                    justifyContent: props.spaceBetween
                        ? 'space-between'
                        : 'flex-start'
                }}
            >
                {props.hideIcon ? '' : icon}
                <span>{props.title}</span>
            </div>
        </button>
    )
}

StartNewButton.propTypes = {
    app: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    rightIcon: PropTypes.bool,
    spaceBetween: PropTypes.bool,
    hideIcon: PropTypes.bool
}

export default StartNewButton
